<script>
import StatInventoryChart from '../../components/StatInventoryChart/StatInventoryChart.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import {mapState, mapActions} from 'vuex';
import { map, get } from 'lodash-es';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        StatInventoryChart,
        DropdownMenu,
        Fake
    },
    data () {
        return {
            chartHeight: 400
        }
    },
    computed: {
        ...mapState({
            loading: state => state.stats.statSites.loading,
            error: state => state.stats.statSites.error,
            noContent: state => state.stats.statSites.noContent,
            period: state => state.stats.period,
            selectedSite: state => state.stats.selectedSite,
            predicate: state => state.stats.statInventory.predicate,
            predicates: state => state.stats.statInventory.predicates
        }),
        chartData () {
            const _chartData = {
                label: 'Sales',
                backgroundColor: '#64C1C7'
            };

            _chartData.data = map(this.filteredAccommodations, (accommodation) => {
                return accommodation[this.predicate];
            });

            return [_chartData];
        },
        labels () {
            return map(this.filteredAccommodations, (accommodation) => {
                return accommodation.name;
            });
        },
        filteredAccommodations () {

            if (!get(this.selectedSite, 'accommodations', undefined)) {
                return undefined;
            }

            let _accommodations = [...this.selectedSite.accommodations];

            _accommodations.sort((a, b) => {
                return b[this.predicate] - a[this.predicate];
            });

            return _accommodations.slice(0, 10);
        },
        options () {
            return {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: (value) => {
                                // Removed all decimal point numbers from the axis.
                                if (value % 1 === 0) {
                                    return this.predicate === 'revenue' ? `€ ${this.$shortNumber(value)}` : value;
                                }
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true
                }
            }
        },
    },
    methods: {
        ...mapActions({
            setFilter: 'stats/setFilter'
        }),
    },
}
</script>

<template>
    <div class="stat-inventory">
        <div v-if="(noContent || error) && !loading"
             :key="'no-content'"
             class="stat-inventory__no-content">
            <div class="stat-inventory__no-content-icon">
                <i class="fa fa-fw fa-exclamation-triangle"/>
            </div>
            <div class="stat-inventory__no-content-message">
                <span v-if="noContent">{{ $t(`statInventory.noContent.missing`) }}</span>
                <span v-if="error">{{ $t(`statInventory.noContent.error`) }}</span>
            </div>
        </div>
        <div v-if="selectedSite && selectedSite.accommodations && !loading"
             :key="'content'"
             class="stat-inventory__content">
            <div class="stat-inventory__header">
                <div v-if="selectedSite && selectedSite.accommodations.length > 10"
                     class="stat-inventory__heading">
                    {{ $t(`statInventory.predicate.${predicate}`) }}: {{ $t(`statInventory.alternativeHeading`) }}
                </div>
                <div v-else class="stat-inventory__heading">
                    {{ $t(`statInventory.predicate.${predicate}`) }}: {{ $t(`statInventory.heading`) }}
                </div>
                <div class="stat-inventory__option">
                    <dropdown-menu :label="$t('statInventory.dropdown.label')"
                                   :value="predicate"
                                   :items="predicates"
                                   :translation-prefix="'statInventory.predicate'"
                                   @input="setFilter({accommodation: $event})"/>
                </div>
            </div>
            <div class="stat-inventory__body">
                <stat-inventory-chart
                    :chart-data="chartData"
                    :labels="labels"
                    :height="chartHeight"
                    :options="options"
                    :filtered-accommodations="filteredAccommodations"/>
            </div>
        </div>
        <fake v-if="loading"
              :header-rows="1"
              :body-rows="10"
              :body-cells="4"
              :key="'fake'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatInventory/StatInventory.vue